var BufferFormatter = require('bufferformatter');
var ContextMenuView = require('contextmenuview');


var BufferContextMenuView = ContextMenuView.extend({
    initialize: function (options) {
        this.actions = this.$('.actions');
        this.buffer = null;
        this.button = null;
        
        _.bindAll(this, 'deactivateButton');
        
        this.afterHide = this.doAfterHide;
        ContextMenuView.prototype.initialize.call(this, options);
    },
    events: $.extend({}, ContextMenuView.prototype.events, {
        'buttonClick button.ignores': 'clickIgnores',
        'buttonClick button.unread': 'clickUnread',
        'buttonClick button.readOnSelect': 'clickReadOnSelect',
        'buttonClick button.muteNotifications': 'clickMuteNotifications',
        'buttonClick button.export': 'clickExport',
        'buttonClick button.clear': 'clickClear',
        'buttonClick button.formatColor': 'clickFormatColor'
    }),
    clickIgnores: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.connection.ignore();
        this.clearContext();
    },
    clickUnread: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setTrackingUnreadPref(!this.buffer.isTrackingUnread());
        this.clearContext();
    },
    clickReadOnSelect: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setMarkAsReadOnSelectPref(!this.buffer.shouldMarkAsReadOnSelect());
        this.clearContext();
    },
    clickMuteNotifications: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setMuteNotificationsPref(!this.buffer.shouldMuteNotifications());
        this.clearContext();
    },
    clickExport: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.session.trigger('exportConfirm', this.buffer);
        this.clearContext();
    },
    clickClear: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.trigger('clear');
        this.clearContext();
    },
    clickFormatColor: function (e) {
        e.preventDefault();
        this.hide();
        this.buffer.setFormatColorPref(!this.buffer.formatColor());
        this.clearContext();
    },
    doAfterHide: function () {
        this.deactivateButton();
    },
    deactivateButton: function () {
        if (this.button) {
            this.button.removeClass('active').attr('aria-expanded', 'false');
        }
    },
    clearContext: function () {
        this.buffer = null;
        this.formatter = null;
        
        this.actions.hide();
        this.$el.removeClass('active');
    },
    onShow: function () {
        // Override in subclasses
    },
    show: function (buffer, button, options) {
        this.clearContext();
        
        this.buffer = buffer;
        this.formatter = new BufferFormatter(this.buffer);
        this.button = button;
        
        this.button.addClass('active').attr('aria-expanded', 'true');
        
        var offset = this.button.offset();
        var x = offset.left + this.button.outerWidth();
        var y = offset.top  + this.button.outerHeight();
                
        // Prefs
        this.enableItem(this.$('li.trackUnread'), this.buffer.isTrackingUnread());
        this.enableItem(this.$('li.markAsReadOnSelect'), this.buffer.shouldMarkAsReadOnSelect());

        this.enableItem(this.$('li.muteNotifications'), this.buffer.shouldMuteNotifications());

        this.enableItem(this.$('li.formatColor'), this.buffer.formatColor());
        
        this.onShow();
        this.actions.show();
        
        ContextMenuView.prototype.show.call(this, x, y, options);
    }
});


module.exports = BufferContextMenuView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/buffercontextmenuview.js
// module id = cmaB
// module chunks = 1